var useSyncExternalStoreShim_production_min = {};
export {
  useSyncExternalStoreShim_production_min as __exports
};
//# sourceMappingURL=use-sync-external-store-shim.production.min.mjs.map
